import { RootState } from "../indexReducers";

// NAVIGATION
export const activeRoute = (state: RootState) =>
  state.navigationReducer.activeRoute;
